import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function OptIn() {
  return (
    <>
      <Helmet>
        <title>Opt-In Information - Aramco Leads Pro</title>
        <meta name="description" content="Learn about SMS and email opt-in requirements for Aramco Leads Pro. TCPA and A2P 10DLC compliant consent procedures." />
      </Helmet>

      <div style={{ background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)', color: 'white', padding: '4rem 2rem', textAlign: 'center' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h1 style={{ fontSize: '3rem', fontWeight: '800', marginBottom: '1rem' }}>Opt-In Information</h1>
          <p style={{ fontSize: '1.25rem', opacity: 0.95 }}>How we collect and manage customer consent</p>
        </div>
      </div>

      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '4rem 2rem' }}>
        <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
          
          <div style={{ background: '#dbeafe', padding: '2rem', borderRadius: '12px', marginBottom: '3rem', border: '2px solid #3b82f6' }}>
            <h2 style={{ color: '#1e40af', marginBottom: '1rem', fontSize: '1.75rem' }}>Our Consent Policy</h2>
            <p style={{ color: '#1e3a8a', lineHeight: '1.8' }}>
              Aramco Leads Pro requires <strong>explicit opt-in consent</strong> before sending any SMS or email communications. 
              We comply with TCPA, CTIA, and A2P 10DLC regulations to ensure all messaging is permission-based.
            </p>
          </div>

          <h2 style={{ color: '#1e40af', marginBottom: '1rem', fontSize: '1.75rem' }}>SMS Opt-In Requirements</h2>
          <p style={{ marginBottom: '1rem', lineHeight: '1.8' }}>
            All SMS opt-ins must include the following disclosures:
          </p>
          <ul style={{ marginBottom: '2rem', paddingLeft: '2rem', lineHeight: '2' }}>
            <li><strong>Clear consent checkbox</strong> - User must actively check a box</li>
            <li><strong>Message frequency disclosure</strong> - "Message frequency varies"</li>
            <li><strong>Cost disclosure</strong> - "Message and data rates may apply"</li>
            <li><strong>Opt-out instructions</strong> - "Reply STOP to opt-out"</li>
            <li><strong>Not a condition statement</strong> - "Consent is not a condition of purchase"</li>
            <li><strong>Help keyword</strong> - "Reply HELP for help"</li>
          </ul>

          <h3 style={{ color: '#1e40af', marginBottom: '1rem', fontSize: '1.5rem' }}>Example SMS Opt-In Language:</h3>
          <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '8px', marginBottom: '2rem', border: '1px solid #e5e7eb' }}>
            <p style={{ fontSize: '0.95rem', lineHeight: '1.8', color: '#1f2937' }}>
              ☐ <strong>I consent to receive SMS messages</strong> from [Business Name] regarding appointments, order updates, and account notifications. 
              Message frequency varies. Message and data rates may apply. Reply STOP to opt-out or HELP for help. 
              <strong>Consent is not a condition of purchase.</strong>
            </p>
          </div>

          <h2 style={{ color: '#1e40af', marginBottom: '1rem', fontSize: '1.75rem' }}>Email Opt-In Requirements</h2>
          <p style={{ marginBottom: '1rem', lineHeight: '1.8' }}>
            Email opt-ins must include:
          </p>
          <ul style={{ marginBottom: '2rem', paddingLeft: '2rem', lineHeight: '2' }}>
            <li><strong>Clear consent checkbox</strong> - User must actively check a box</li>
            <li><strong>Purpose disclosure</strong> - What types of emails will be sent</li>
            <li><strong>Unsubscribe option</strong> - Easy way to opt-out</li>
            <li><strong>Privacy policy link</strong> - Link to privacy policy</li>
          </ul>

          <h3 style={{ color: '#1e40af', marginBottom: '1rem', fontSize: '1.5rem' }}>Example Email Opt-In Language:</h3>
          <div style={{ background: '#f9fafb', padding: '1.5rem', borderRadius: '8px', marginBottom: '2rem', border: '1px solid #e5e7eb' }}>
            <p style={{ fontSize: '0.95rem', lineHeight: '1.8', color: '#1f2937' }}>
              ☐ <strong>I consent to receive email communications</strong> from [Business Name] regarding my account, services, and updates. 
              I can unsubscribe at any time by clicking the unsubscribe link in emails.
            </p>
          </div>

          <h2 style={{ color: '#1e40af', marginBottom: '1rem', fontSize: '1.75rem' }}>Consent Record Keeping</h2>
          <p style={{ marginBottom: '1rem', lineHeight: '1.8' }}>
            For compliance, we record:
          </p>
          <ul style={{ marginBottom: '2rem', paddingLeft: '2rem', lineHeight: '2' }}>
            <li>Date and time of consent</li>
            <li>IP address of user</li>
            <li>Exact consent language shown</li>
            <li>Method of opt-in (web form, in-person, etc.)</li>
            <li>User's contact information</li>
          </ul>

          <div style={{ background: '#fee2e2', padding: '1.5rem', borderRadius: '8px', marginBottom: '2rem', border: '2px solid #ef4444' }}>
            <h3 style={{ color: '#991b1b', marginBottom: '0.75rem', fontSize: '1.25rem' }}>⚠️ What is NOT Acceptable:</h3>
            <ul style={{ color: '#7f1d1d', paddingLeft: '2rem', lineHeight: '2' }}>
              <li>Pre-checked consent boxes</li>
              <li>Implied consent without explicit checkbox</li>
              <li>Purchased or scraped contact lists</li>
              <li>Consent buried in terms and conditions</li>
              <li>Vague or unclear consent language</li>
            </ul>
          </div>

          <h2 style={{ color: '#1e40af', marginBottom: '1rem', fontSize: '1.75rem' }}>Opt-Out Compliance</h2>
          <p style={{ marginBottom: '1rem', lineHeight: '1.8' }}>
            All messages must include easy opt-out:
          </p>
          <ul style={{ marginBottom: '2rem', paddingLeft: '2rem', lineHeight: '2' }}>
            <li><strong>SMS:</strong> "Reply STOP to opt-out" in every message</li>
            <li><strong>Email:</strong> Unsubscribe link in every email</li>
            <li><strong>Processing:</strong> Opt-outs processed immediately</li>
            <li><strong>Confirmation:</strong> Confirmation message sent upon opt-out</li>
          </ul>

          <div style={{ background: '#dcfce7', padding: '1.5rem', borderRadius: '8px', border: '2px solid #10b981' }}>
            <h3 style={{ color: '#065f46', marginBottom: '0.75rem', fontSize: '1.25rem' }}>✓ Best Practices:</h3>
            <ul style={{ color: '#064e3b', paddingLeft: '2rem', lineHeight: '2' }}>
              <li>Use clear, simple language</li>
              <li>Make consent checkboxes prominent</li>
              <li>Separate SMS and email consent</li>
              <li>Keep records of all opt-ins</li>
              <li>Honor opt-outs immediately</li>
              <li>Regularly audit consent records</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
